// extracted by mini-css-extract-plugin
export default {"dropdown":"DropdownComments_dropdown__EldtB","active":"DropdownComments_active__rm2tV","head":"DropdownComments_head__R14rk"};